import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AppAntd, ConfigProvider } from "antd";
import ErrorBoundary from "antd/es/alert/ErrorBoundary";
import ptBr from "antd/locale/pt_BR";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { useOidcConfig } from "./hooks/useOidcConfig";
import { persistor, store } from "./store";

export function Providers({ children }: { children: React.ReactNode }) {
  const queryClient = new QueryClient();
  const config = useOidcConfig();

  return (
    <ErrorBoundary>
      <AuthProvider {...config}>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <AppAntd
                notification={{
                  duration: 3,
                  placement: "top",
                  showProgress: true,
                }}
              >
                <ConfigProvider
                  locale={ptBr}
                  theme={{
                    token: {
                      colorPrimary: "#0e2a37", // cor principal ajustada
                      colorSuccess: "#2ECC40",
                      colorError: "#D7263D",
                      colorTextBase: "#212121",
                      colorBorder: "#E0E0E0",
                    },
                    components: {
                      Layout: {
                        siderBg: "#1F5772",
                      },
                      Menu: {
                        darkItemBg: "#1F5772",
                        darkItemColor: "#fff",
                        darkItemSelectedBg: "#0e2a37",
                        darkDangerItemActiveBg: "#fff",
                        darkSubMenuItemBg: "#153C4F",
                        darkPopupBg: "#153C4F",
                      },
                      Card: {
                        colorBgContainer: "#0e2a37",
                        colorText: "#fff",
                      },
                      Button: {
                        colorPrimary: "#0e2a37",
                        primaryShadow: "none",
                      },
                      Collapse: {
                        contentPadding: "16px", // Espaçamento interno do conteúdo
                        borderRadius: 8, // Bordas arredondadas
                        colorBorderBg: "#E0E0E0", // Cor da borda
                      },
                    },
                  }}
                >
                  {children}
                </ConfigProvider>
              </AppAntd>
            </PersistGate>
          </Provider>
        </QueryClientProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
